import PropTypes from 'prop-types';

import { MainHeader } from 'app/layout/components/Header';
import classNames from 'classnames/bind';

import { useSendJWTTokenToExtension } from 'features/extension/hooks/useSendTokenToExtension';

import styles from 'app/layout/components/Layout/Layout.module.css';

const cx = classNames.bind(styles);

export const AuthenticatedLayout = ({ children }) => {
  useSendJWTTokenToExtension();

  const isInIframe = window.self !== window.top;

  return (
    <div className={styles.layout}>
      <div className={cx('main-wrapper')}>
        {!isInIframe && <MainHeader />}
        <main className={cx('main-content')}>{children}</main>
      </div>
    </div>
  );
};

AuthenticatedLayout.propTypes = {
  children: PropTypes.node.isRequired,
};
